import React from 'react'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'

const withStyles = makeStyles((theme) => ({
  heading: {
    fontSize: 16,
    fontFamily: 'Montserrat, Arial, sans-serif',
    fontWeight: 700
  }
}))

const Heading = ({ children, margin = true }) => {
  const classes = withStyles()

  return (
    <Box mt={margin ? 3 : 0}>
      <Typography variant="overline" className={classes.heading}>{children}</Typography>
    </Box>
  )
}

export default Heading
